import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function ENOUWAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <g>
        <path
          fill="#fff"
          d="M113.45,51.51c-.1-1.71-1.41-2.84-3.25-2.8-8.12.16-15.7-1.35-23.07-4.5-3.97-1.7-7.3-4.07-10.96-6.47-.88-.58-2.51.06-3.28.63-9.72,7.21-21.21,10.46-33.72,10.34-1.21-.01-2.48,1.02-2.56,2.23-1.89,28.38,6.9,52.67,32.68,68.71,1.98,1.23,3.73,2.29,6.15,2.86,28.94-15.37,39.8-40.59,38.01-70.99ZM83.76,99.62l-4.7.04h-8.3s-4.52-.04-4.52-.04c-.05-.27-.05-.63,0-.94,1.42-.4,2.73-1.44,2.79-2.94l.07-1.99,8.19.02h3.46c.33,2.89.12,3.86,3.05,5.02l-.02.83ZM100.24,92.27h-50.45c-.49-.17-.88-.4-1.35-.69v-35.22c.34-.34.66-.58,1.11-.78h50.9c.53.17.85.64,1.11,1.13v34.47c-.32.51-.67.84-1.32,1.1Z"
        />
        <path
          fill="#fff"
          d="M86.02,65.32c-.99-.82-2.47-.53-3.17-.15l-.27.15-10.42,11.45-4.56-4.55c-.69-.69-1.66-.7-2.17-.65-.5.05-1.43.26-1.95,1.07-.73,1.12-.36,2.73.45,3.53l6.04,5.99c.59.58,1.37.91,2.2.91h.08c.93-.02,1.86-.46,2.51-1.17l12.01-13.15.09-.5c.13-.72.11-2.14-.83-2.91Z"
        />
      </g>
    </svg>
  );
}
